import { createSlice, } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        isAuthenticated: false,
        hotel: null,
        company_id: null,
        adminHotels:null,
        is_trial: false,
        trial : null
    },
    reducers: {
        clearCredentials: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.hotel = null;
            state.adminHotels = null;
            state.company_id = null;
            state.is_trial = false;
            state.trial = null;
            sessionStorage.removeItem("user_key");
            sessionStorage.removeItem("hotel_key");
        },
        setCredentials: (state, action) => {
            const { user, hotel, adminHotels, is_trial, trial, company_id } = action.payload
            state.user = user;
            state.isAuthenticated = true;
            state.hotel = hotel;
            state.company_id = company_id;
            state.adminHotels = adminHotels;
            state.is_trial = is_trial;
            state.trial = trial;
        },
        updateTrial: (state, action) => {
            state.trial = action.payload;
          }
    },

});

export const { clearCredentials, setCredentials, updateTrial } = authSlice.actions;
export const selectAuthData = (state) => state.auth;
export default authSlice.reducer;
